import { CONTACT_API } from 'modules/contacts/api/contact-api'
import { ContactId, ContactInterface } from 'modules/contacts/types/contact-interface'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'

export function useContact(id: ContactId) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, ContactInterface>({
    method: RequestMethodsEnum.get,
  })

  return useControlledSwr(() => {
    if (user) {
      return [`${CONTACT_API}/contacts/${id}`, RequestModuleEnum.Tags]
    }
  }, fetcher)
}
